import Slider from "react-slick";
const isBrowser = typeof window !== "undefined";

const FeaturedProducts = ({ featuredProducts }) => {
  let slidesToShow = 3;
  if(featuredProducts.length < 3 && featuredProducts.length > 0){
    slidesToShow = featuredProducts.length;
  }
  const settings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: slidesToShow,
    slidesToScroll: 1,
    nextArrow: <SampleNextArrow />,
    prevArrow: <SamplePrevArrow />
  };

  // const testarraydouble = [...featuredProducts, ...featuredProducts];

  return (
    <div className="featuredProducts">
      <h1>Featured Products</h1>
      {featuredProducts.length > 0 ? (
        <Slider {...settings}>
          {featuredProducts?.map(product => (
                <div key={product.id} className="featuredProductCard">
                  <img
                    className="featuredProductImage"
                    src={product?.images[0]}
                    alt={product.title}
                  />
                  <h2 className="featuredProductTitle">{product?.title}</h2>
                  <a
                    className="featuredProductBrand"
                    href={"/brands/" + product?.contentProducts?.brand?.slug}
                  >
                    {product?.brand_name}
                  </a>
                  <a
                    className="featuredProductShopNow"
                    target="_blank"
                    href={product?.contentProducts?.affiliateUrl}
                  >
                    Shop Now
                  </a>
                </div>
              ))
            }
        </Slider>
      ) : (
        "No Products Selected"
      )}
    </div>
  );
};

function SampleNextArrow(props) {
  const { className, style, onClick } = props;
  return (
    <div className={className + " featuredSliderArrow"} onClick={onClick}>
      <div className="mobile-only">
        <svg
          width="17"
          height="17"
          viewBox="0 0 17 17"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M16.8535 8.28427C16.8535 3.99238 13.2627 0.512753 8.83366 0.512753C4.40461 0.512752 0.813796 3.99237 0.813796 8.28427C0.813795 12.5762 4.40461 16.0558 8.83366 16.0558C13.2627 16.0558 16.8535 12.5762 16.8535 8.28427ZM8.65437 11.6978C8.59684 11.6425 8.55111 11.5767 8.5198 11.5043C8.48849 11.4319 8.47221 11.3542 8.47189 11.2757C8.47157 11.1972 8.48721 11.1194 8.51792 11.0467C8.54864 10.974 8.59382 10.908 8.6509 10.8522L10.6682 8.88208L5.51775 8.88208C5.35414 8.88208 5.19722 8.81909 5.08153 8.70698C4.96584 8.59487 4.90084 8.44282 4.90084 8.28427C4.90084 8.12572 4.96584 7.97366 5.08153 7.86155C5.19722 7.74944 5.35414 7.68646 5.51775 7.68646L10.6682 7.68646L8.6509 5.71631C8.59383 5.66052 8.54867 5.59438 8.51798 5.52168C8.48729 5.44898 8.47168 5.37113 8.47203 5.29258C8.47239 5.21403 8.48871 5.13632 8.52006 5.06388C8.55141 4.99145 8.59718 4.9257 8.65475 4.87041C8.71232 4.81511 8.78057 4.77134 8.8556 4.7416C8.93062 4.71186 9.01096 4.69674 9.09202 4.69708C9.17308 4.69743 9.25327 4.71324 9.32802 4.74362C9.40277 4.774 9.47062 4.81835 9.52768 4.87414L12.5887 7.86319C12.7034 7.97516 12.7677 8.12652 12.7677 8.28427C12.7677 8.44202 12.7034 8.59338 12.5887 8.70535L9.52768 11.6944C9.47061 11.7503 9.40273 11.7947 9.32792 11.8251C9.25312 11.8555 9.17286 11.8713 9.09174 11.8716C9.01063 11.8719 8.93024 11.8567 8.85519 11.8269C8.78014 11.7971 8.7119 11.7532 8.65437 11.6978Z"
            fill="black"
          />
        </svg>
      </div>
      <div className="desktop-only">
        <svg
          width="55"
          height="53"
          viewBox="0 0 55 53"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M54.4395 26.3237C54.4395 11.9829 42.4412 0.356219 27.6421 0.356218C12.843 0.356217 0.844799 11.9829 0.844798 26.3237C0.844796 40.6645 12.843 52.2913 27.6421 52.2913C42.4412 52.2913 54.4395 40.6646 54.4395 26.3237ZM27.0431 37.7295C26.8508 37.5447 26.698 37.3251 26.5934 37.0831C26.4888 36.8411 26.4344 36.5815 26.4333 36.3192C26.4323 36.0568 26.4845 35.7968 26.5872 35.5541C26.6898 35.3113 26.8408 35.0905 27.0315 34.9043L33.772 28.3212L16.5625 28.3212C16.0158 28.3212 15.4915 28.1108 15.1049 27.7362C14.7183 27.3616 14.5011 26.8535 14.5011 26.3237C14.5011 25.794 14.7183 25.2859 15.1049 24.9113C15.4915 24.5367 16.0158 24.3262 16.5625 24.3262L33.772 24.3262L27.0315 17.7432C26.8408 17.5568 26.6899 17.3358 26.5873 17.0929C26.4848 16.85 26.4326 16.5899 26.4338 16.3274C26.435 16.0649 26.4895 15.8053 26.5943 15.5632C26.6991 15.3212 26.852 15.1015 27.0443 14.9168C27.2367 14.732 27.4647 14.5857 27.7154 14.4864C27.9661 14.387 28.2346 14.3365 28.5054 14.3376C28.7763 14.3388 29.0442 14.3916 29.294 14.4931C29.5438 14.5946 29.7705 14.7428 29.9611 14.9292L40.1892 24.9168C40.5723 25.2909 40.7873 25.7966 40.7873 26.3237C40.7873 26.8508 40.5723 27.3566 40.1892 27.7307L29.9611 37.7182C29.7704 37.9049 29.5436 38.0533 29.2937 38.1549C29.0437 38.2564 28.7755 38.3093 28.5045 38.3103C28.2334 38.3114 27.9649 38.2606 27.7141 38.1609C27.4633 38.0613 27.2353 37.9146 27.0431 37.7295Z"
            fill="black"
          />
        </svg>
      </div>
    </div>
  );
}

function SamplePrevArrow(props) {
  const { className, style, onClick } = props;
  return (
    <div className={className + " featuredSliderArrow"} onClick={onClick}>
      <div className="mobile-only">
        <svg
          width="17"
          height="17"
          viewBox="0 0 17 17"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M0.620605 8.28433C0.620605 12.5762 4.21142 16.0559 8.64047 16.0559C13.0695 16.0559 16.6603 12.5762 16.6603 8.28433C16.6603 3.99244 13.0695 0.512817 8.64047 0.512817C4.21142 0.512817 0.620605 3.99244 0.620605 8.28433ZM8.81976 4.87084C8.87728 4.92614 8.92301 4.99187 8.95432 5.06429C8.98563 5.13671 9.00191 5.21439 9.00223 5.29291C9.00255 5.37143 8.98691 5.44924 8.9562 5.5219C8.92548 5.59455 8.8803 5.66064 8.82323 5.71637L6.80592 7.68652H11.9564C12.12 7.68652 12.2769 7.74951 12.3926 7.86162C12.5083 7.97373 12.5733 8.12578 12.5733 8.28433C12.5733 8.44288 12.5083 8.59494 12.3926 8.70705C12.2769 8.81916 12.12 8.88214 11.9564 8.88214H6.80592L8.82323 10.8523C8.88029 10.9081 8.92546 10.9742 8.95615 11.0469C8.98683 11.1196 9.00245 11.1975 9.00209 11.276C9.00173 11.3546 8.98541 11.4323 8.95406 11.5047C8.92271 11.5772 8.87694 11.6429 8.81937 11.6982C8.7618 11.7535 8.69355 11.7973 8.61853 11.827C8.5435 11.8567 8.46316 11.8719 8.38211 11.8715C8.30105 11.8712 8.22085 11.8554 8.1461 11.825C8.07135 11.7946 8.0035 11.7502 7.94644 11.6945L4.8854 8.70541C4.77073 8.59344 4.70639 8.44208 4.70639 8.28433C4.70639 8.12658 4.77073 7.97523 4.8854 7.86325L7.94644 4.87421C8.00351 4.81835 8.07139 4.77394 8.1462 4.74354C8.221 4.71313 8.30126 4.69732 8.38238 4.69701C8.4635 4.6967 8.54388 4.71189 8.61893 4.74172C8.69398 4.77155 8.76223 4.81543 8.81976 4.87084Z"
            fill="black"
          />
        </svg>
      </div>
      <div className="desktop-only">
        <svg
          width="54"
          height="53"
          viewBox="0 0 54 53"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M0.34668 26.3237C0.34668 40.6645 12.3449 52.2912 27.144 52.2912C41.9431 52.2912 53.9413 40.6645 53.9413 26.3237C53.9413 11.9829 41.9431 0.356201 27.144 0.356201C12.3449 0.356201 0.34668 11.9829 0.34668 26.3237ZM27.7431 14.918C27.9353 15.1027 28.0881 15.3224 28.1927 15.5644C28.2973 15.8063 28.3517 16.0659 28.3528 16.3283C28.3539 16.5906 28.3016 16.8506 28.199 17.0934C28.0964 17.3362 27.9454 17.557 27.7547 17.7432L21.0141 24.3262H38.2237C38.7704 24.3262 39.2947 24.5367 39.6813 24.9113C40.0678 25.2859 40.285 25.794 40.285 26.3237C40.285 26.8535 40.0678 27.3616 39.6813 27.7362C39.2947 28.1108 38.7704 28.3212 38.2237 28.3212H21.0141L27.7547 34.9042C27.9453 35.0906 28.0963 35.3116 28.1988 35.5546C28.3014 35.7975 28.3535 36.0576 28.3523 36.3201C28.3511 36.5825 28.2966 36.8422 28.1918 37.0842C28.0871 37.3263 27.9342 37.5459 27.7418 37.7307C27.5494 37.9155 27.3214 38.0617 27.0707 38.1611C26.82 38.2605 26.5516 38.311 26.2807 38.3098C26.0099 38.3087 25.7419 38.2558 25.4921 38.1543C25.2424 38.0528 25.0157 37.9046 24.825 37.7182L14.5969 27.7307C14.2138 27.3566 13.9988 26.8508 13.9988 26.3237C13.9988 25.7966 14.2138 25.2909 14.5969 24.9167L24.825 14.9292C25.0157 14.7426 25.2425 14.5942 25.4925 14.4926C25.7424 14.391 26.0106 14.3382 26.2816 14.3371C26.5527 14.3361 26.8213 14.3869 27.0721 14.4865C27.3228 14.5862 27.5509 14.7328 27.7431 14.918Z"
            fill="black"
          />
        </svg>
      </div>
    </div>
  );
}

export default FeaturedProducts;
